
import { i18nText } from '@/locales';
import { RouterNameEnum } from '@/router/router.types'
export const HomeRoutes = [
  {
    path: '/dashboard',
    redirect: '/index',
    component: ():any => import('@/UI/layouts/MainLayout.vue'),
    meta: {
      auth: true
    },
    children: [{
      path: ('/'),
      component: ():any => import('@/UI/pages/dashboard/Index.vue'),
      name: RouterNameEnum.Dashboard,
      meta: {
        title: i18nText("Дашборд"),
        breadcrumb: [{ name: i18nText("Дашборд") }]
      }

    }]
  }
]
